import { isSiteCanadian } from 'src/utils/helpers';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import './styles.scss';

const LanguageSelector: React.FC = () => {
    const { i18n } = useTranslation();
    const [active, setActive] = useState<string>(
        isSiteCanadian() ? 'en-CA' : 'en-US',
    );
    function changeLanguage(lang: string) {
        setActive(lang);
        i18n.changeLanguage(lang);
    }

    return (
        <div className={'footer-language u-mb-large'}>
            <i
                className={'c-icon c-icon--[globe] u-mr-xsmall'}
                aria-hidden='true'
                role='img'
            ></i>
            <a className={'c-link'}>
                <span className='c-link__body'>
                    <span
                        className={`c-link__effect ${
                            active.includes('en-') ? 'active-link' : ''
                        }`}
                        onClick={() =>
                            changeLanguage(isSiteCanadian() ? 'en-CA' : 'en-US')
                        }
                    >
                        English
                    </span>
                </span>
            </a>
            <span className={'u-ml-xxsmall u-mr-xxsmall'}>|</span>
            <a className={'c-link'}>
                <span className='c-link__body  '>
                    <span
                        className={`c-link__effect ${
                            active.includes('fr-CA') ? 'active-link' : ''
                        }`}
                        onClick={() => changeLanguage('fr-CA')}
                    >
                        Francais
                    </span>
                </span>
            </a>
        </div>
    );
};

export default LanguageSelector;
